<template>
  <QuestionBase :question="question" :errors="[...serverErrors, ...jsErrors]" :valid="data !== null">
    <InputRadio
        v-model="data"
        :options="booleanYesNo"
        :db="db"
        :args="args"
        :skipped="skipped"
        @skipped="skipped=$event"
        @serverErrors="serverErrors=$event"
        @jsErrors="jsErrors=$event"
    />
  </QuestionBase>
</template>

<script>
import { willRelationshipHelpers } from "../../../../fieldsets/will/helpers/willRelationshipHelpers";
import { willPeopleHelpers } from "../../../../fieldsets/will/helpers/willPeopleHelpers";
import { questionLoadHelpers } from "../../../helpers/questionLoadHelpers";
import { general } from "../../../options/general";

import QuestionBase from "../../../QuestionBase";
import InputRadio from "../../../inputs/InputRadio";

export default {
  name: 'SeparatePets',
  mixins: [questionLoadHelpers, willPeopleHelpers, willRelationshipHelpers, general],
  components: {
    InputRadio,
    QuestionBase
  },
  props: {
    value: {
      type: Boolean,
      required: false
    },
    callbackFunction: {
      type: Function,
      required: true
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
      },
      get () {
        return this.value
      }
    }
  },
  data () {
    return {
      question: {
        title:  'Would you like to name people to look after your pets?',
        subTitle: 'Adding provision for the family goldfish could be considered unnecessary, but it may be worth making provisions in your Will for cats, dogs and other common pets.',
        tip: null,
      },
      db: {
        saveLocation: 'product_will_data',
        saveField: 'separatePets',
        formPath: 'data.pets.details.separatePets',
        jsonSaveField: 'separatePets',
        callbackFunction: this.callbackFunction
      },
      args: {
        skippable: false,
        required: true,
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false
    }
  }
}
</script>
